import React from 'react';
import Tab from '@mui/material/Tab';
import {Link} from 'react-router-dom';

interface LockTabProps {
    label?: string;
    to: string;
    value: string;
    selected?: boolean;
}

function LockTab(props: LockTabProps) {

    return <Tab component={Link} {...props} disableRipple />
}

export default LockTab;